import React, { useState, useContext, useEffect } from 'react'

import { Form, Input, Modal } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { MaskedInput } from 'antd-mask-input'
import SL_Date from '../../components/dates/Date';
import moment from 'moment'
import SL_Select from '../../components/selects/Select';
import { Option } from 'antd/lib/mentions';
import { displayMessage } from '../../services/helper';

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function DetailDentist(props) {

    const [form] = Form.useForm()

    const [dentist, setDentist] = useState(null)
    const [edit_mode, setEditMode] = useState(false)

    const {setShowLoading, windowHeight} = useContext(GeneralContext)
    
    useEffect(() => {
        loadDentist()
    }, [])

    function loadDentist() {
        setShowLoading(true)

        api.dentist.get(props.dentist_id)
            .then(
                rs => {
                    const dentist_formatted = formatSpecialization(rs?.data)
                    dentist_formatted.birth_date = moment(dentist_formatted.birth_date)

                    setDentist(dentist_formatted)
                    form.setFieldsValue(dentist_formatted)
                }
            )
            .finally(
                setShowLoading(false)
            )
    }
    const formatSpecialization = dentist => {
        if (!dentist) { return null }

        const specialization_object = dentist.specialization
        dentist.specialization_object = specialization_object
        dentist.specialization = specialization_object?.map( s => s?.code )
        
        return dentist
    }
    const handleUpdateDentist = (values) => {
        setShowLoading(true)
        values.id = dentist.id

        values.specialization = mountSpecialization(values.specialization) // formatando valores pois select nao aceitou objetos como value
        api.dentist.update(values)
            .then(
                rs => {
                    
                    alert(displayMessage('CREATE_PATIENT_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshDentists()
                    props.handleOnCloseModal()
                }
            ).finally(
                () => {
                    setShowLoading(false)
                }
            )
    }

    const mountSpecialization = specializations => {
        return specializations?.map(
            s => {
                switch (s) {
                    case 1:
                        return { code: 1, name: displayMessage('DENTIST_1') }
                    case 2:
                        return { code: 2, name: displayMessage('DENTIST_2') }
                    case 3:
                        return { code: 3, name: displayMessage('DENTIST_3') }
                }
            }
        )
    }

    const phoneField = placeholder => {
        if (edit_mode) {
            return (
                <MaskedInput
                    type="text"
                    size='large'
                    placeholder={placeholder}
                    className={inputsClassName}
                    defaultValue={dentist?.cell_phone}
                    mask={'(00) 00000-0000'}
                />
            )
        } else {
            return (
                <div style={{ fontSize: 16, border: '1px solid #1c3663', padding: 5, paddingTop: 4, paddingLeft: 11, background: '#f5f5f5', color: '#b7b7b7' }}>
                    { dentist?.cell_phone }
                </div>
            )
        }
    }

    const cpfField = placeholder => {
        if (edit_mode) {
            return (
                <MaskedInput
                    type="text"
                    size='large'
                    placeholder={placeholder}
                    className={inputsClassName}
                    defaultValue={dentist?.cpf}
                    mask={'000.000.000-00'}
                />
            )
        } else {
            return (
                <div style={{ fontSize: 16, border: '1px solid #1c3663', padding: 5, paddingTop: 4, paddingLeft: 11, background: '#f5f5f5', color: '#b7b7b7' }}>
                    { dentist?.cpf }
                </div>
            )
        }

    }

    const modalHeader = (
            <div className="flex flex-row">
                <div className="text-xl font-bold text-appian-blue">
                    {displayMessage('DETAIL_PATIENT')}
                </div>
                <div style={{ marginLeft: 10}}>
                    <SL_Button
                        type={edit_mode ? "danger" : "primary"}
                        styles={{ maxWidth: 100 }}
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                        onClick={
                            e => {
                                setEditMode(!edit_mode)
                                form.setFieldsValue(dentist)

                            }
                        }
                    >
                        {edit_mode ? displayMessage('CANCEL') : displayMessage('EDIT')}
                    </SL_Button>
                </div>
                
            </div>
    )
            
        
    return (
        <Modal
            title={modalHeader}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            width={750}
            style={{position: 'relative'}}
            footer={<div></div>}
            bodyStyle={{ maxHeight: windowHeight*0.8, overflow: 'auto'}}
        >
            <Form
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleUpdateDentist}
                layout="vertical"
                requiredMark='optional'
                form={form}
            >
            <div>
                <div className='font-bold text-lg text-appian-blue text-center'>{displayMessage('PATIENT_DATA')}</div>
                    <Form.Item
                        label={displayMessage('NAME')}
                        name="first_name"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('NAME')}
                            className={inputsClassName}
                        />
                    </Form.Item>
                    <Form.Item
                        label={displayMessage('LAST_NAME')}
                        name="last_name"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('LAST_NAME')}
                            className={inputsClassName}

                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('CPF')}
                        name="cpf"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('CPF') }]}
                    >
                        {
                            cpfField(displayMessage('CPF'))
                        }
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('EMAIL')}
                        name="email"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('EMAIL'), type: "email", }]}
                    >
                        <Input
                            type="email"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('EMAIL')+displayMessage('EMAIL_EXEMPLE')}
                            className={inputsClassName}

                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('BIRTHDAY')}
                        name="birth_date"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('CPF') }]}
                    >
                        <SL_Date
                            className={inputsClassName}
                            disabled={!edit_mode}
                            style={{ width: '100%', height: 110}}
                            format={'DD/MM/YYYY'}
                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('PHONE_WHATSAPP')}
                        name="cell_phone"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('CPF') }]}
                    >
                        {
                            phoneField(displayMessage('PHONE_WHATSAPP'))
                        }
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('CRO_NAME')}
                        name="cro_number"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('CRO_NAME') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('IDENTIFICATOR_DENTIST')}
                            className={inputsClassName}

                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('SPECIALIZATION')}
                        name="specialization"
                        rules={[{ required: true }]}
                    >
                        <SL_Select
                            disabled={!edit_mode}
                            allowClear
                            mode="multiple"
                            placeholder={displayMessage('SELECT_OPTION')}
                            style={{
                                width: '100%',
                                display: null
                            }}
                        >
                            <Option value={1}>{displayMessage('DENTIST_1')}</Option>
                            <Option value={2}>{displayMessage('DENTIST_2')}</Option>
                            <Option value={3}>{displayMessage('DENTIST_3')}</Option>
                        </SL_Select>
                    </Form.Item>

                {
                    edit_mode ?
                    <SL_Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                    >
                        {displayMessage('UPDATE_PATIENT')}
                    </SL_Button>
                    :
                    null
                }
                
                </div>
            </Form>
        </Modal >
    )
}

